export type Project = {
  name: string
  discipline: string
  description: string
  accent: string
  surface: string
  artwork: 'kitcord' | 'lilypad' | 'solvage' | 'pulse' | 'koru' | 'lunary' | 'districtp' | 'devforms'
}

export const PROJECTS: Project[] = [
  {
    name: 'Kitcord',
    discipline: 'No-code automation',
    description: 'Visual no-code Discord bot builder. Drag pieces, connect flows, deploy instantly.',
    accent: '#c084fc',
    surface: '#f3e8ff',
    artwork: 'kitcord',
  },
  {
    name: 'Lilypad',
    discipline: 'Solana NFT launchpad',
    description: 'Full NFT launchpad on Solana. Mint, launch, and manage collections end to end.',
    accent: '#7ed957',
    surface: '#eaffd6',
    artwork: 'lilypad',
  },
  {
    name: 'SOLVage',
    discipline: 'Wallet utility',
    description: 'Solana wallet cleanup tool. Reclaim SOL from dead token accounts, with a 5% platform fee.',
    accent: '#5b7cff',
    surface: '#e8ebff',
    artwork: 'solvage',
  },
  {
    name: 'Pulse',
    discipline: 'Trading tournaments',
    description: 'Solana trading tournament platform with real-time memecoin data, SOL prize pools, and prediction markets.',
    accent: '#fb7185',
    surface: '#ffe1e7',
    artwork: 'pulse',
  },
  {
    name: 'Koru',
    discipline: 'NFT ecosystem suite',
    description: 'Launchpad, delayed reveal, and staking — all built around one collection.',
    accent: '#84cc16',
    surface: '#efffd8',
    artwork: 'koru',
  },
  {
    name: 'Lunary',
    discipline: 'Discord Web3 wallet',
    description: 'Send, swap, trade, and view your portfolio without ever leaving Discord.',
    accent: '#818cf8',
    surface: '#e7e9ff',
    artwork: 'lunary',
  },
  {
    name: 'DistrictP',
    discipline: 'NFT quest game',
    description: 'Send NFTs on quests, earn $BBK backed by liquidity, and adapt to dynamic weather and day/night odds.',
    accent: '#eeab79',
    surface: '#fff0e4',
    artwork: 'districtp',
  },
  {
    name: 'DevForms',
    discipline: 'Agent-native forms',
    description: 'AI-native form builder with device auth, MCP cards, and forms agents can create and embed autonomously.',
    accent: '#b3d17a',
    surface: '#eef6dd',
    artwork: 'devforms',
  },
]
